<template>
  <div class="c-simple-form-box">
    <div class="c-simple-form-box__content">
      <form novalidate>

        <form-select
          name="title"
          v-bind:id="'aboutYouTitle'"
          v-bind:label="aboutYouTitleLabel"
          v-bind:options="titleOptions" 
          v-bind:required="true"
          v-bind:validationError="titleError"
          v-bind:validationMessage="'Please select a title'"
          v-model="innerTitle"
          v-on:change="valueChange($event, 'title')">
        </form-select>

        <form-input
          name="other-title"
          v-bind:id="'aboutYouOtherTitle'"
          v-bind:label="aboutYouOtherTitleLabel"
          v-bind:required="true"
          v-bind:validationError="otherTitleError"
          v-bind:validationMessage="'Please enter a title'"
          v-if="showOtherTitle"
          v-model="innerOtherTitle"
          v-on:input="valueChange($event, 'otherTitle')">
        </form-input>

        <form-input
          name="name"
          v-bind:id="'aboutYouFirstName'"
          v-bind:label="aboutYouFirstNameLabel"
          v-bind:required="true"
          v-bind:validationError="firstNameError"
          v-bind:validationMessage="'Please enter a first name'"
          v-model="innerFirstName"
          v-on:input="valueChange($event, 'firstName')">
        </form-input>

        <form-input
          name="surname"
          v-bind:id="'aboutYouSurname'"
          v-bind:label="aboutYouSurnameLabel"
          v-bind:required="true"
          v-bind:validationError="surnameError"
          v-bind:validationMessage="'Please enter a surname'"
          v-model="innerSurname"
          v-on:input="valueChange($event, 'surname')">
        </form-input>

        <form-input
          name="email"
          v-bind:id="'aboutYouEmail'"
           v-bind:required="true"
          v-bind:label="aboutYouEmailLabel"
          v-bind:validationError="emailError"
          v-bind:validationMessage="'Please enter a valid email address (e.g. example@wessexwater.co.uk)'"
          v-model="innerEmail"
          v-on:input="valueChange($event, 'email')">
        </form-input>

        <form-input
          name="mobile-phone"
          type="tel"
          autocomplete="mobile tel"
          v-bind:id="'aboutYouPrimaryContact'"
          v-bind:label="aboutYouPrimaryContactLabel"
          v-bind:required="true"
          v-bind:validationError="primaryContactError"
          v-bind:validationMessage="'Please enter a phone number containing numbers only with no spaces'"
          v-model="innerPrimaryContact"
          v-on:input="valueChange($event, 'primaryContact')">
        </form-input>

        <form-input
          name="home-phone"
          type="tel"
          autocomplete="home tel"
          v-bind:id="'aboutYouSecondaryContact'"
          v-bind:label="aboutYouSecondaryContactLabel"
          v-bind:validationError="secondaryContactError"
          v-bind:validationMessage="'Please enter a phone number containing numbers only with no spaces'"
          v-model="innerSecondaryContact"
          v-on:input="valueChange($event, 'secondaryContact')">
        </form-input>

        <div class="c-summary-box__actions">
          <button 
            class="c-button c-button--brand c-button--text-center" 
            type="button" 
            v-on:click="resetForm">
            {{ backButtonText }}
          </button>
          <button 
            class="c-button c-button--brand c-button--text-center"
            type="submit"
            v-on:click="checkForm">
            {{ continueButtonText }}
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import FormInput from './FormInput';
import FormSelect from './FormSelect';

export default {
  components: {
    FormInput,
    FormSelect,
  },
  props: {
    aboutYouEmailLabel: {
      required: true,
      type: String,
    },
    aboutYouFirstNameLabel: {
      required: true,
      type: String,
    },
    aboutYouOtherTitleLabel: {
      required: true,
      type: String,
    },
    aboutYouPrimaryContactLabel: {
      required: true,
      type: String,
    },
    aboutYouSecondaryContactLabel: {
      required: true,
      type: String,
    },
    aboutYouSurnameLabel: {
      required: true,
      type: String,
    },
    aboutYouTitleLabel: {
      required: true,
      type: String,
    },
    backButtonText: {
      required: true,
      type: String
    },
    continueButtonText: {
      required: true,
      type: String
    },
    email: {
      required: true,
      type: String,
    },
    firstName: {
      required: true,
      type: String,
    },
    otherTitle: {
      required: true,
      type: String,
    },
    primaryContact: {
      required: true,
      type: String,
    },
    secondaryContact: {
      required: true,
      type: String,
    },
    surname: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    }
  },
  watch: {
    email(newVal) {
      this.innerEmail = newVal;
    },
    firstName(newVal) {
      this.innerFirstName = newVal;
    },
    innerEmail(newVal) {
      this.valueChange(newVal, 'email');
    },
    innerFirstName(newVal) {
      this.valueChange(newVal, 'firstName');
    },
    innerOtherTitle(newVal) {
      this.valueChange(newVal, 'otherTitle');
    },
    innerPrimaryContact(newVal) {
      this.valueChange(newVal, 'primaryContact');
    },
    innerSecondaryContact(newVal) {
      this.valueChange(newVal, 'secondaryContact');
    },
    innerSurname(newVal) {
      this.valueChange(newVal, 'surname');
    },
    innerTitle(newVal) {
      this.valueChange(newVal, 'title');
    },
    otherTitle(newVal) {
      this.innerOtherTitle = newVal;
    },
    primaryContact(newVal) {
      this.innerPrimaryContact = newVal;
    },
    secondaryContact(newVal) {
      this.innerSecondaryContact = newVal;
    },
    surname(newVal) {
      this.innerSurname = newVal;
    },
    title(newVal) {
      this.innerTitle = newVal;
    },
  },
  computed: {
    emailError() {
      return this.locationSubmitted === true && this.email === '' || (this.email !== '' &&  this.validEmail(this.email) === false);
    },
    firstNameError() {
      return this.locationSubmitted === true && this.firstName === '';
    },
    otherTitleError() {
       return this.locationSubmitted === true && this.otherTitle === '' && this.title === 'Other';
    },
    primaryContactError() {
      return this.locationSubmitted === true && (this.primaryContact === '' || (this.primaryContact !== '' && this.validPhoneNumber(this.primaryContact) === false));
    },
    secondaryContactError() {
      return this.locationSubmitted === true && this.secondaryContact !== '' && this.validPhoneNumber(this.secondaryContact) === false;
    },
    showOtherTitle() {
      return (this.title === 'Other');
    },
    surnameError() {
      return this.locationSubmitted === true && this.surname === '';
    },
    titleError() {
      return this.locationSubmitted === true && this.title === '';
    },
  },
  created() {
    this.innerEmail = this.email;
    this.innerFirstName = this.firstName;
    this.innerOtherTitle = this.otherTitle;
    this.innerPrimaryContact = this.primaryContact;
    this.innerSecondaryContact = this.secondaryContact;
    this.innerSurname = this.surname;
    this.innerTitle = this.title;
  },
  data() {
    return {
      innerEmail: '',      
      innerFirstName: '',      
      locationSubmitted: false,
      innerOtherTitle: '',
      innerPrimaryContact: '',      
      innerPriorityServices: false,
      innerSecondaryContact: '',      
      innerSurname: '',      
      innerTitle: '',      
      titleOptions: [
        {
          label: 'Mr',
          value: 'Mr',
        },
        {
          label: 'Mrs',
          value: 'Mrs',
        },
        {
          label: 'Miss',
          value: 'Miss',
        },
        {
          label: 'Ms',
          value: 'Ms',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ]
    }
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      this.locationSubmitted = true;
      if (this.emailError === false &&
        this.firstNameError === false &&
        this.otherTitleError === false &&
        this.primaryContactError === false &&
        this.secondaryContactError === false &&
        this.surnameError === false &&
        this.titleError === false) {
        this.$emit('collateDetails');
      }
    },
    resetForm() {
      this.innerEmail = '';
      this.innerFirstName = '';
      this.innerOtherTitle = '';
      this.innerPrimaryContact = '';
      this.innerSecondaryContact = '';
      this.innerSurname = '';
      this.innerTitle = '';
      this.locationSubmitted = false;
      this.$emit('stepChange', 2);
    },
    validEmail(email) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailRegex.test(email);
    },
    validPhoneNumber(phone) {
      const phoneRegex = /^[+0-9][0-9]*$/;
      return phoneRegex.test(phone);
    },
    valueChange(value, key) {
      this.$emit('valueChange', key, value);
    }
  }
}
</script>
 


// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/FormBox.vue